export default __webpack_public_path__ + "static/media/Teresa.68ac8816.jpg";